import React from 'react';
import CreateReactClass from 'create-react-class';
import { Immutable } from 'nuclear-js';

import RuntimeActions from 'data/app-runtime/actions';
import CommonStrings from 'resources/common-strings';

export default CreateReactClass({
    displayName: 'create-pdf-failure',

    closeAlert() {
        RuntimeActions.setPageAlert(
            Immutable.Map({
                messageContent: null,
                isActive: false,
                actionStatus: '',
            })
        );
    },

    render() {
        return (
            <div className="failure-state">
                <span className="icon icon-error" />
                <span>
                    <strong>We were unable to create your PDF.</strong>
                    <br />
                    Please try again later.
                </span>
                <span className="icon-close" onClick={this.closeAlert}>
                    {CommonStrings.collapse}
                </span>
            </div>
        );
    },
});
